import React, { useState } from "react";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUE_CONTRACTS } from "../../../service/ApolloClient/ApolloQueries";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box, Button, IconButton } from "@material-ui/core";
import AutoCompleteMU from "../../UI/AutoCompleteMU/AutoCompleteMU";
import { Link } from "react-router-dom";
import { RemoveRedEye } from "@material-ui/icons";

const ChequeAddFormChequeableCheque = (props) => {
  const { title, setFieldValue, value, fieldName, fieldNameShow, typeCheck } =
    props;
  const [keyword, setKeyword] = useState(props.value);
  const [modalOpen, setModalOpen] = useState(false);
  const query = client.query({
    query: QUERY_CHEQUE_CONTRACTS,
    variables: {
      keyword: keyword,
      limit: 20,
      page: 1,
    },
    fetchPolicy: "network-only",
  });

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Wrapper>
      <Box display={"flex"} p={1}>
        <Box flexGrow={1}>
          <AutoCompleteMU
            fieldNameShow={"chequeable_name"}
            value={value ? value : ""}
            title={
              typeCheck === "cheque_contract_recieved"
                ? "انتخاب خرید دین - چک ورودی"
                : "انتخاب خرید دین - چک خروجی"
            }
            setFieldValue={setFieldValue}
            keyword={keyword}
            setKeyword={setKeyword}
            query={query}
            queryName={"chequeContracts"}
            field={["id", "first_party_fullname", "second_party_fullname"]}
            fieldSelect={"id"}
            fieldName={"chequeable_id"}
          />
        </Box>
        <Box>
          <Button>
            <Link
              to={`/cheque-contract/edit/${props.values.chequeable_id}`}
              target={"_blank"}
            >
              <IconButton>
                <RemoveRedEye />
              </IconButton>
            </Link>
          </Button>
        </Box>
      </Box>
    </Wrapper>
  );
};

export default React.memo(ChequeAddFormChequeableCheque);
